export default class PaymentModalService {
/**
 * @param {string} quantityOrder - The quantity of the order
 * @param {string} subscriptionType - The type of the subscription
 * @param {string} coupon - The coupon code
 * @param {string} currency - The currency of the order
 * @param {string} cardBtnActiion - The action for the card button
 * @param {string} paypalBtnAction - The action for the paypal button (also used by the UPI button: both send service_name = me-qr)
 * @param {boolean} isAllowedForPayPal - Whether the currency is supported by PayPal
 * @param {boolean} isAllowedForUpi - Whether the currency is supported by UPI (takes priority over PayPal)
 * @param {number} krwAmount - The price of the selected plan in KRW (for Naver Ads conversion)
 * @param {string} planName - The display name of the selected plan (for ad conversions)
 */
  static setChoosePaymentMethodActions({
    quantityOrder,
    subscriptionType,
    coupon,
    currency,
    cardBtnActiion,
    paypalBtnAction,
    isAllowedForPayPal = true,
    isAllowedForUpi = false,
    krwAmount,
    planName,
  }) {
    const modal = document.querySelector("#choosePaymentMethod");
    const creditCardBtn = modal.querySelector(".btn-credit-card");
    const paypalBtn = modal.querySelector(".btn-paypal");
    const upiBtn = modal.querySelector(".btn-upi");
    const paypalMethod = modal.querySelector(".paypal-method");
    const upiMethod = modal.querySelector(".upi-method");

    creditCardBtn.setAttribute(
      "data-action",
      `click->payment--choose-payment-method-modal#${cardBtnActiion}`
    );
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-card-action-value",
      cardBtnActiion
    );

    const alternativeBtn = isAllowedForUpi ? upiBtn : isAllowedForPayPal ? paypalBtn : null;
    [paypalBtn, upiBtn].forEach((btn) => {
      if (btn === alternativeBtn) {
        btn.setAttribute(
          "data-action",
          `click->payment--choose-payment-method-modal#${paypalBtnAction}`
        );
      } else {
        btn.removeAttribute("data-action");
      }
    });
    paypalMethod.classList.toggle("d-none", alternativeBtn !== paypalBtn);
    upiMethod.classList.toggle("d-none", alternativeBtn !== upiBtn);

    modal.setAttribute(
      "data-payment--choose-payment-method-modal-direct-card-value",
      String(alternativeBtn === null)
    );

    currency && modal.setAttribute(
      "data-payment--choose-payment-method-modal-currency-value",
      currency
    );
    coupon &&
      modal.setAttribute(
        "data-payment--choose-payment-method-modal-coupon-value",
        coupon
      );
    quantityOrder &&
      modal.setAttribute(
        "data-payment--choose-payment-method-modal-quantity-order-value",
        quantityOrder
      );
    subscriptionType &&
      modal.setAttribute(
        "data-payment--choose-payment-method-modal-subscription-type-value",
        subscriptionType
      );
    if (Number.isFinite(krwAmount)) {
      modal.setAttribute(
        "data-payment--choose-payment-method-modal-krw-amount-value",
        krwAmount
      );
    } else {
      modal.removeAttribute("data-payment--choose-payment-method-modal-krw-amount-value");
    }
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-plan-name-value",
      planName ?? ""
    );
  }
}
